export const gtinRegex = /^(?:\d{8}|\d{12,14})$/;

export const getIsRecognizedHeaderPredicate = (header: string) => (recHeading: string) =>
  header.toLowerCase().includes(recHeading);

export const recognizedPurchasePriceHeadings = [
  'purchaseprice',
  'purchase-price',
  'purchase price',
  'price',
];
